import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { ToastAction, ToastService } from '../../../core/services/toast.service';
import { TranslatePipe } from '../../pipes/translate.pipe';
import { ButtonComponent } from '../button/button.component';
import { ProgressBarComponent } from '../progress-bar/progress-bar.component';

@Component({
  selector: 'app-toast',
  standalone: true,
  imports: [ProgressBarComponent, ButtonComponent, TranslatePipe],
  templateUrl: './toast.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './toast.component.css',
})
export class ToastComponent {
  toastService = inject(ToastService);

  dismiss(id: string): void {
    this.toastService.dismiss(id);
  }

  async handleAction(toastId: string, action: ToastAction): Promise<void> {
    await action.onClick();
    // Auto-dismiss toast after action is clicked
    this.dismiss(toastId);
  }
}
